// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__HpGr3","ntrl":"Tag_ntrl__M+wxy","primary":"Tag_primary__MpV2X","secondary":"Tag_secondary__dDj4f","negative":"Tag_negative__7QnTL"};